import { CrewMember, MarkerType } from '@bechtel/types';
import { WeldFilterInput } from '~/search-bar/types';

export interface MapMarkersProps {
  crewMember: CrewMember;
  weldFilter?: WeldFilterInput;
  selectedMarkerTypes?: MarkerType[];
  onFilterChange?: (markerTypes: MarkerType[]) => void;
}

export enum ConnectionType {
  PIPE = 'PIPE',
}
